module.exports = __webpack_public_path__ + "static/media/CheckedCheckboxIcon.5d7aa695.svg";